export const complianceConfirmationStyles = {
	root: {
		width: '100%'
	},

	checkbox: {
		py: 0,
		pl: 0,
		pr: 1,
		'& .MuiSvgIcon-root': {
			fontSize: 20,
			width: 20,
			height: 20
		}
	},

	checkboxFormControl: {
		alignItems: 'center',
		ml: 0,
		mr: 0,
		width: '100%'
	},

	complianceConfirmationText: {
		fontSize: '0.75rem',
		color: 'text.fadedPrimary'
	}
};
